import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { SuiteAppBar } from "@fg/ui-theme";
import { useAppearanceSync } from "@fg/ui-theme";
import { ShellHeaderContext } from "./ShellHeader";

export function PdfShell() {
    const auth = useAuth();
    const profile = auth.user?.profile;
    const user = {
        name: profile?.name ?? profile?.email ?? "Signed in",
        email: profile?.email
    };

    // The suite look follows the account: GET/PUT /api/me/appearance on the
    // Drive BFF (PDF's token carries the fg.drive scope).
    useAppearanceSync(import.meta.env.VITE_DRIVE_BFF_BASE_URL, auth.user?.access_token);

    // PdfPage portals the open file's name + save status into this slot.
    const [headerSlot, setHeaderSlot] = useState<HTMLDivElement | null>(null);

    return (
        <ShellHeaderContext.Provider value={headerSlot}>
            <div className="flex h-screen flex-col bg-background text-foreground">
                <a
                    href="#main-content"
                    className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded-md focus:bg-primary focus:px-3 focus:py-1 focus:text-sm focus:text-primary-foreground"
                >
                    Skip to main content
                </a>
                <SuiteAppBar
                    app="pdf"
                    user={user}
                    onSignOut={() => void auth.signoutRedirect()}
                    title={<div ref={setHeaderSlot} className="flex min-w-0 flex-1 items-center gap-2" />}
                />
                <main id="main-content" tabIndex={-1} className="flex min-h-0 flex-1 flex-col">
                    <Outlet />
                </main>
            </div>
        </ShellHeaderContext.Provider>
    );
}
